import React from 'react';
import { getTranslation, getTranslationByCount } from '../../utils/config';
import { usePinned } from '../../hooks/use-pinned';
import Share from '../share';
import Toast from '../toast';
import { useDfContext } from '../../context/df-context';

export default function BookmarkTitle(): React.ReactElement {
  const { pins } = usePinned();
  const {
    state: { loggedIn },
  } = useDfContext();

  const bookmarkDownloadAmount = `${String(pins.length)} ${getTranslationByCount(
    pins.length,
    'bookmark_title_zero_downloads',
    'bookmark_title_download',
    'bookmark_title_downloads',
  )}`;

  return (
    <div className="section-content section-title">
      <Toast />
      <div className="container">
        <div className="row flex">
          <div className="col col-12">
            <section className="df-section-bookmark-title df-text">
              <div className="df-share-page">
                <Share type="bookmarks" />
              </div>
              <h2
                className="df-sub-headline"
                dangerouslySetInnerHTML={{
                  __html: getTranslation('bookmark_subtitle', bookmarkDownloadAmount),
                }}
              />
              <p dangerouslySetInnerHTML={{ __html: getTranslation('bookmark_introtext_1') }} />
              <p
                dangerouslySetInnerHTML={{ __html: getTranslation('bookmark_introtext_2') }}
                className={`${loggedIn ? 'hidden' : ''}`}
              />
              <p
                dangerouslySetInnerHTML={{ __html: getTranslation('bookmark_introtext_3') }}
                className={`${loggedIn ? 'hidden' : ''}`}
              />
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
